import { withTranslation } from "react-i18next";
import WithRouter from "../../../../../components/Common/WithRouter";
import React, { useRef, useState } from "react";
import { ConfirmPopup } from 'primereact/confirmpopup';
import StateLessGrid from "../../../../../components/Shared/StateLessGrid";
import QuickCopyDropdown from "../../../../../components/Shared/QuickCopyDropdown";
import { Button } from "primereact/button";
import { Col, Row } from "react-bootstrap";
import { Field, Form, Formik, FormikProps } from "formik";
import { InputField } from "../../../../../components/Shared/InputField";
import { utcDateToLocalDate } from "../../../../../utils/Helper";
import { ButtonGroup } from "primereact/buttongroup";
import ReceivedFilter from "./ReceivedFilter";

const ReceivedList = (props: any) => {
    const { t, moduleState } = props;
    const [initSearchFormState] = useState<any>({
        search: moduleState.search ?? null
    });
    const tableRef: any = useRef();
    const [total, setTotal] = useState(0);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [filterPanel, setFilterPanel] = useState<boolean>(false);

    const columns = [
        {
            field: 'load_number',
            title: t('load number'),
            sorting: false,
            render: (_row: any) => ( JSON.parse(_row.response) || {} ).load_number,
        },
        {
            field: 'event_type',
            title: t('event type'),
        },
        {
            field: 'provider_title',
            title: t('provider'),
            render: (_row: any) => _row.provider_title || '-',
        },
        {
            field: 'status',
            title: t('status'),
            render: (_row: any) => <span className="text-uppercase">{ _row.status }</span>,
        },
        {
            field: 'created_at', title: t('created at'),
            allowHiding: true,
            render: (_row: any) => utcDateToLocalDate(_row.created_at)
        },
    ];

    const onReset = () => {
        tableRef.current.onRefresh();
    };

    const onFilterClick = () => {
        setFilterPanel(true);
    };

    const onSearch = ({ search }: any) => {
        props.setQuery({
            ...moduleState,
            search: search
        });
    };

    const DetailRow = ({ data }: any) => {
        return (
            <div>
                <table>
                    <tbody>
                        {
                            Object.keys(JSON.parse(data.response)).map(function (key: any, index: any) {
                                // @ts-ignore
                                const _data = JSON.parse(data.response);
                                return (
                                    <tr key={ index }>
                                        <td>{ key }</td>
                                        <td>{ _data[key] }</td>
                                    </tr>
                                );
                            })
                        }
                        <tr>
                            <td>{ t("errors") }</td>
                            <td>{ data.errors }</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <div className={ "block-viewer" }>
            <div className="block-section">
                <div className="block-header">
                    <span className="block-title">
                        <h5 className={ "mb-0" }>ALP { t('webhook') } ({total})</h5>
                    </span>
                    <div className="block-actions">
                    </div>
                </div>
                <div className="block-content">
                    <Row className={ "p-2" }>
                        <Col
                            sm={ 12 } md={ 6 } className={ "mb-2" }>
                            <Formik
                                enableReinitialize={ true }
                                initialValues={ initSearchFormState }
                                onSubmit={ onSearch }
                            >
                                { (props: FormikProps<any>) => {
                                    return (
                                        <Form onSubmit={ props.handleSubmit }>
                                            <Col sm={ 12 } md={ 8 }>
                                                <Field component={ InputField } withoutLabel={ true }
                                                       autoFocus={ true }
                                                       name="search"
                                                       formGroupClass={ "mb-0" }
                                                       placeholder={ t("search") } />
                                            </Col>
                                        </Form>
                                    );
                                } }
                            </Formik>
                        </Col>

                        <Col
                            sm={ 12 } md={ 6 } className={ "text-right mb-2" }>
                                <div className="d-inline-block me-2 align-middle text-left">
                                    <QuickCopyDropdown
                                        columns={ columns }
                                        tableName={ "receivedWebhookList" }
                                        selectedRows={ selectedRows }
                                        trackBy={ "id" }
                                        // @ts-ignore
                                        entities={ tableRef.current?.getEntities?.() || [] }
                                    />
                                </div>
                                <ButtonGroup>
                                    <Button icon="pi pi-filter-fill" size={ "small" } outlined tooltip={ t('filter') }
                                            onClick={ onFilterClick }
                                            tooltipOptions={ { position: 'top' } } />
                                    <Button onClick={ onReset } icon="pi pi-refresh" size={ "small" } outlined
                                            tooltip={ t('reset') }
                                            tooltipOptions={ { position: 'top' } } />
                                </ButtonGroup>
                        </Col>

                        <Col sm={ 12 }>
                            <StateLessGrid
                                size={ "normal" }
                                url={ '/suppliers/received/webhook/logs?1=1' }
                                name={ "receivedWebhookList" }
                                columns={ columns }
                                moduleState={ moduleState }
                                setQuery={ props.setQuery }
                                ref={ tableRef }
                                itemSize={ 45 }
                                setTotal={ setTotal }
                                stickyHeader={ true }
                                showQuickCopy={ false }
                                onRowSelection={ setSelectedRows }
                                selectedRows={ selectedRows }
                                detailRow={ (data: any) => <DetailRow data={ data } /> }
                            />
                        </Col>
                    </Row>

                    <ReceivedFilter
                        moduleState={ moduleState }
                        setQuery={ props.setQuery }
                        visibility={ filterPanel }
                        onClose={ () => setFilterPanel(false) }
                    />

                    <ConfirmPopup />
                </div>
            </div>
        </div>
    );
};

ReceivedList.propTypes = {
    // t: PropTypes.any,
};

export default withTranslation()(WithRouter(ReceivedList));
